export const mockKnowledgePosts = [
  // Exploit (7개)
  {
    id: 'knowledge1',
    user_id: 'researcher1',
    type: 'knowledge' as const,
    title: 'CVE-2025-0282 Ivanti Connect Secure 제로데이 익스플로잇 분석',
    content: 'Ivanti Connect Secure의 최신 제로데이 취약점에 대한 상세 분석입니다. 스택 기반 버퍼 오버플로우를 통한 원격 코드 실행이 가능하며, 인증 없이 공격 가능합니다. PoC 코드와 함께 패치 우회 기법도 공유합니다.',
    tags: ['cve-2025-0282', 'ivanti', 'rce', 'zero-day'],
    status: 'open',
    likes_count: 234,
    replies_count: 45,
    views_count: 3421,
    created_at: new Date(Date.now() - 2 * 3600000).toISOString(),
    profiles: {
      id: 'researcher1',
      username: 'exploit_master',
      display_name: 'Exploit Master',
      points: 4520,
      reputation: 892
    }
  },
  {
    id: 'knowledge2',
    user_id: 'researcher2',
    type: 'knowledge' as const,
    title: 'Windows Kernel Use-After-Free 취약점 익스플로잇 체인 구축',
    content: 'Windows 11 커널의 UAF 취약점을 이용한 권한 상승 익스플로잇 체인을 구축했습니다. KASLR 우회부터 SMEP/SMAP 우회까지 전체 과정을 설명합니다. 실제 동작하는 PoC 포함.',
    tags: ['windows', 'kernel', 'uaf', 'privilege-escalation'],
    status: 'open',
    likes_count: 312,
    replies_count: 67,
    views_count: 4892,
    created_at: new Date(Date.now() - 6 * 3600000).toISOString(),
    profiles: {
      id: 'researcher2',
      username: 'kernel_hacker',
      display_name: 'Kernel Hacker',
      points: 5890,
      reputation: 1245
    }
  },
  {
    id: 'knowledge3',
    user_id: 'researcher3',
    type: 'knowledge' as const,
    title: 'Chrome V8 엔진 타입 혼동 취약점 분석 및 익스플로잇',
    content: 'Chrome V8 JavaScript 엔진의 타입 혼동 취약점을 발견했습니다. JIT 컴파일러의 최적화 과정에서 발생하는 문제로, 샌드박스 탈출까지 가능합니다. 상세한 루트 원인 분석과 익스플로잇 기법 공유.',
    tags: ['chrome', 'v8', 'type-confusion', 'sandbox-escape'],
    status: 'solved',
    likes_count: 289,
    replies_count: 52,
    views_count: 4156,
    created_at: new Date(Date.now() - 12 * 3600000).toISOString(),
    profiles: {
      id: 'researcher3',
      username: 'browser_pwner',
      display_name: 'Browser Pwner',
      points: 5340,
      reputation: 1089
    }
  },
  {
    id: 'knowledge4',
    user_id: 'researcher4',
    type: 'knowledge' as const,
    title: 'Linux Kernel eBPF Verifier 우회 기법 연구',
    content: 'eBPF verifier의 검증 로직을 우회하여 커널 메모리에 임의 접근하는 방법을 연구했습니다. CVE-2024-XXXX 취약점을 활용한 실제 익스플로잇 시나리오 포함.',
    tags: ['linux', 'ebpf', 'kernel', 'verifier-bypass'],
    status: 'open',
    likes_count: 267,
    replies_count: 48,
    views_count: 3789,
    created_at: new Date(Date.now() - 18 * 3600000).toISOString(),
    profiles: {
      id: 'researcher4',
      username: 'ebpf_researcher',
      display_name: 'eBPF Researcher',
      points: 4980,
      reputation: 967
    }
  },
  {
    id: 'knowledge5',
    user_id: 'researcher5',
    type: 'knowledge' as const,
    title: 'iOS WebKit 메모리 손상 취약점 익스플로잇 개발',
    content: 'iOS Safari의 WebKit 엔진에서 발견한 메모리 손상 취약점입니다. JSC (JavaScriptCore)의 힙 오버플로우를 이용해 샌드박스 탈출과 코드 실행이 가능합니다.',
    tags: ['ios', 'webkit', 'memory-corruption', 'exploit'],
    status: 'open',
    likes_count: 298,
    replies_count: 61,
    views_count: 4523,
    created_at: new Date(Date.now() - 24 * 3600000).toISOString(),
    profiles: {
      id: 'researcher5',
      username: 'ios_pwner',
      display_name: 'iOS Pwner',
      points: 5670,
      reputation: 1178
    }
  },
  {
    id: 'knowledge6',
    user_id: 'researcher6',
    type: 'knowledge' as const,
    title: 'Apache Struts2 OGNL Injection 신규 우회 기법',
    content: 'Apache Struts2의 OGNL 표현식 인젝션 취약점에 대한 새로운 우회 기법을 발견했습니다. 기존 패치를 우회하여 원격 코드 실행이 가능합니다. 실제 환경 테스트 결과 포함.',
    tags: ['struts2', 'ognl', 'injection', 'bypass'],
    status: 'solved',
    likes_count: 245,
    replies_count: 43,
    views_count: 3654,
    created_at: new Date(Date.now() - 30 * 3600000).toISOString(),
    profiles: {
      id: 'researcher6',
      username: 'java_exploiter',
      display_name: 'Java Exploiter',
      points: 4720,
      reputation: 923
    }
  },
  {
    id: 'knowledge7',
    user_id: 'researcher7',
    type: 'knowledge' as const,
    title: 'Kubernetes API Server 권한 상승 취약점 분석',
    content: 'Kubernetes API Server의 RBAC 검증 로직 우회를 통한 권한 상승 취약점입니다. 일반 사용자 권한으로 클러스터 관리자 권한을 획득할 수 있습니다. 패치 전 버전 대상 PoC 공개.',
    tags: ['kubernetes', 'api-server', 'privilege-escalation', 'rbac'],
    status: 'open',
    likes_count: 321,
    replies_count: 72,
    views_count: 5234,
    created_at: new Date(Date.now() - 36 * 3600000).toISOString(),
    profiles: {
      id: 'researcher7',
      username: 'k8s_exploiter',
      display_name: 'K8s Exploiter',
      points: 6120,
      reputation: 1356
    }
  },

  // Defense (6개)
  {
    id: 'knowledge8',
    user_id: 'defender1',
    type: 'knowledge' as const,
    title: 'EDR 우회 기법 탐지를 위한 행위 기반 룰셋 개발',
    content: 'EDR 솔루션을 우회하는 최신 공격 기법들을 탐지하기 위한 행위 기반 탐지 룰을 개발했습니다. Process Injection, DLL Sideloading, AMSI Bypass 등 주요 기법 탐지 가능.',
    tags: ['edr', 'detection', 'behavioral-analysis', 'defense'],
    status: 'open',
    likes_count: 198,
    replies_count: 38,
    views_count: 2987,
    created_at: new Date(Date.now() - 42 * 3600000).toISOString(),
    profiles: {
      id: 'defender1',
      username: 'blue_team_lead',
      display_name: 'Blue Team Lead',
      points: 4230,
      reputation: 834
    }
  },
  {
    id: 'knowledge9',
    user_id: 'defender2',
    type: 'knowledge' as const,
    title: 'YARA 룰 작성 베스트 프랙티스 - 악성코드 탐지 최적화',
    content: '효과적인 YARA 룰 작성 방법과 성능 최적화 기법을 정리했습니다. False Positive를 최소화하면서 탐지율을 높이는 실전 노하우 공유. 실제 사용 중인 룰셋 예제 포함.',
    tags: ['yara', 'malware-detection', 'rules', 'optimization'],
    status: 'solved',
    likes_count: 176,
    replies_count: 32,
    views_count: 2654,
    created_at: new Date(Date.now() - 48 * 3600000).toISOString(),
    profiles: {
      id: 'defender2',
      username: 'malware_hunter',
      display_name: 'Malware Hunter',
      points: 3890,
      reputation: 756
    }
  },
  {
    id: 'knowledge10',
    user_id: 'defender3',
    type: 'knowledge' as const,
    title: 'Sigma 룰을 활용한 SIEM 탐지 로직 구축',
    content: 'Sigma 룰 형식으로 작성한 범용 탐지 로직을 Splunk, ELK, QRadar 등 다양한 SIEM에 적용하는 방법입니다. MITRE ATT&CK 프레임워크 기반 탐지 커버리지 분석 포함.',
    tags: ['sigma', 'siem', 'detection', 'mitre-attack'],
    status: 'open',
    likes_count: 212,
    replies_count: 41,
    views_count: 3123,
    created_at: new Date(Date.now() - 54 * 3600000).toISOString(),
    profiles: {
      id: 'defender3',
      username: 'siem_architect',
      display_name: 'SIEM Architect',
      points: 4560,
      reputation: 891
    }
  },
  {
    id: 'knowledge11',
    user_id: 'defender4',
    type: 'knowledge' as const,
    title: 'Threat Hunting 방법론 - 가설 기반 위협 탐색',
    content: '능동적인 위협 탐색(Threat Hunting)을 위한 체계적인 방법론을 정리했습니다. 가설 수립부터 데이터 분석, 탐지 룰 생성까지 전체 프로세스 설명. 실제 사례 연구 포함.',
    tags: ['threat-hunting', 'methodology', 'detection', 'soc'],
    status: 'open',
    likes_count: 234,
    replies_count: 47,
    views_count: 3567,
    created_at: new Date(Date.now() - 60 * 3600000).toISOString(),
    profiles: {
      id: 'defender4',
      username: 'threat_hunter',
      display_name: 'Threat Hunter',
      points: 4890,
      reputation: 945
    }
  },
  {
    id: 'knowledge12',
    user_id: 'defender5',
    type: 'knowledge' as const,
    title: 'Zeek (Bro) 네트워크 트래픽 분석 스크립트 모음',
    content: 'Zeek를 활용한 네트워크 이상 탐지 스크립트 모음입니다. C2 통신 탐지, DNS 터널링 탐지, 비정상 TLS 핸드셰이크 탐지 등 실전 스크립트 공유.',
    tags: ['zeek', 'network-analysis', 'detection', 'scripts'],
    status: 'solved',
    likes_count: 189,
    replies_count: 35,
    views_count: 2876,
    created_at: new Date(Date.now() - 66 * 3600000).toISOString(),
    profiles: {
      id: 'defender5',
      username: 'network_defender',
      display_name: 'Network Defender',
      points: 4120,
      reputation: 812
    }
  },
  {
    id: 'knowledge13',
    user_id: 'defender6',
    type: 'knowledge' as const,
    title: 'Incident Response 플레이북 - 랜섬웨어 대응 절차',
    content: '랜섬웨어 공격 발생 시 초기 대응부터 복구까지 전체 절차를 정리한 플레이북입니다. 격리, 분석, 복구 단계별 체크리스트와 실제 대응 사례 포함.',
    tags: ['incident-response', 'ransomware', 'playbook', 'recovery'],
    status: 'open',
    likes_count: 267,
    replies_count: 53,
    views_count: 4012,
    created_at: new Date(Date.now() - 72 * 3600000).toISOString(),
    profiles: {
      id: 'defender6',
      username: 'ir_specialist',
      display_name: 'IR Specialist',
      points: 5230,
      reputation: 1034
    }
  },

  // Tools (6개)
  {
    id: 'knowledge14',
    user_id: 'tooldev1',
    type: 'knowledge' as const,
    title: 'Nuclei 템플릿 작성 가이드 - 자동화된 취약점 스캐닝',
    content: 'Nuclei 프레임워크를 활용한 커스텀 취약점 스캔 템플릿 작성 방법입니다. YAML 문법부터 고급 매칭 기법까지 상세히 설명. 실전 템플릿 50개 포함.',
    tags: ['nuclei', 'vulnerability-scanning', 'automation', 'templates'],
    status: 'open',
    likes_count: 223,
    replies_count: 44,
    views_count: 3345,
    created_at: new Date(Date.now() - 78 * 3600000).toISOString(),
    profiles: {
      id: 'tooldev1',
      username: 'nuclei_master',
      display_name: 'Nuclei Master',
      points: 4670,
      reputation: 912
    }
  },
  {
    id: 'knowledge15',
    user_id: 'tooldev2',
    type: 'knowledge' as const,
    title: 'Metasploit 모듈 개발 튜토리얼 - 커스텀 익스플로잇',
    content: 'Metasploit Framework에서 커스텀 익스플로잇 모듈을 개발하는 방법입니다. Ruby 기반 모듈 구조부터 페이로드 통합까지 전체 과정 설명. 실제 동작하는 예제 코드 포함.',
    tags: ['metasploit', 'module-development', 'exploit', 'ruby'],
    status: 'solved',
    likes_count: 198,
    replies_count: 37,
    views_count: 2987,
    created_at: new Date(Date.now() - 84 * 3600000).toISOString(),
    profiles: {
      id: 'tooldev2',
      username: 'msf_developer',
      display_name: 'MSF Developer',
      points: 4340,
      reputation: 856
    }
  },
  {
    id: 'knowledge16',
    user_id: 'tooldev3',
    type: 'knowledge' as const,
    title: 'Frida 스크립트로 Android 앱 동적 분석하기',
    content: 'Frida를 사용한 Android 앱 런타임 후킹 기법입니다. SSL Pinning 우회, 메서드 후킹, 메모리 덤프 등 실전 스크립트 모음. JavaScript API 활용법 상세 설명.',
    tags: ['frida', 'android', 'dynamic-analysis', 'hooking'],
    status: 'open',
    likes_count: 289,
    replies_count: 58,
    views_count: 4234,
    created_at: new Date(Date.now() - 90 * 3600000).toISOString(),
    profiles: {
      id: 'tooldev3',
      username: 'frida_expert',
      display_name: 'Frida Expert',
      points: 5120,
      reputation: 1012
    }
  },
  {
    id: 'knowledge17',
    user_id: 'tooldev4',
    type: 'knowledge' as const,
    title: 'Cobalt Strike Aggressor Script 개발 - C2 자동화',
    content: 'Cobalt Strike의 Aggressor Script를 활용한 C2 작업 자동화 방법입니다. 비콘 관리, 자동 권한 상승, 정보 수집 자동화 등 실전 스크립트 공유.',
    tags: ['cobalt-strike', 'aggressor-script', 'c2', 'automation'],
    status: 'open',
    likes_count: 256,
    replies_count: 49,
    views_count: 3789,
    created_at: new Date(Date.now() - 96 * 3600000).toISOString(),
    profiles: {
      id: 'tooldev4',
      username: 'redteam_dev',
      display_name: 'RedTeam Dev',
      points: 4890,
      reputation: 967
    }
  },
  {
    id: 'knowledge18',
    user_id: 'tooldev5',
    type: 'knowledge' as const,
    title: 'Burp Suite Extension 개발 - 커스텀 스캐너 플러그인',
    content: 'Burp Suite의 Java API를 활용한 커스텀 익스텐션 개발 가이드입니다. 자동화된 취약점 스캐너, 커스텀 인코더/디코더 등 실용적인 플러그인 예제 포함.',
    tags: ['burp-suite', 'extension', 'java', 'plugin-development'],
    status: 'solved',
    likes_count: 212,
    replies_count: 41,
    views_count: 3156,
    created_at: new Date(Date.now() - 102 * 3600000).toISOString(),
    profiles: {
      id: 'tooldev5',
      username: 'burp_developer',
      display_name: 'Burp Developer',
      points: 4560,
      reputation: 891
    }
  },
  {
    id: 'knowledge19',
    user_id: 'tooldev6',
    type: 'knowledge' as const,
    title: 'BloodHound 커스텀 쿼리 작성 - Active Directory 분석',
    content: 'BloodHound의 Cypher 쿼리를 활용한 고급 AD 분석 기법입니다. 공격 경로 탐색, 권한 관계 분석, 취약한 설정 탐지 등 실전 쿼리 모음.',
    tags: ['bloodhound', 'active-directory', 'cypher', 'analysis'],
    status: 'open',
    likes_count: 234,
    replies_count: 46,
    views_count: 3567,
    created_at: new Date(Date.now() - 108 * 3600000).toISOString(),
    profiles: {
      id: 'tooldev6',
      username: 'ad_analyst',
      display_name: 'AD Analyst',
      points: 4780,
      reputation: 934
    }
  },

  // Research (6개)
  {
    id: 'knowledge20',
    user_id: 'researcher8',
    type: 'knowledge' as const,
    title: 'AI 기반 피싱 공격 탐지 모델 개발 연구',
    content: '머신러닝을 활용한 피싱 이메일 자동 탐지 시스템 연구입니다. NLP 기반 텍스트 분석과 URL 특징 추출을 결합하여 98.7%의 탐지율 달성. 학습 데이터셋과 모델 아키텍처 공개.',
    tags: ['ai', 'phishing-detection', 'machine-learning', 'research'],
    status: 'open',
    likes_count: 312,
    replies_count: 64,
    views_count: 4892,
    created_at: new Date(Date.now() - 114 * 3600000).toISOString(),
    profiles: {
      id: 'researcher8',
      username: 'ai_security_researcher',
      display_name: 'AI Security Researcher',
      points: 5890,
      reputation: 1234
    }
  },
  {
    id: 'knowledge21',
    user_id: 'researcher9',
    type: 'knowledge' as const,
    title: 'Fuzzing 기법 비교 연구 - AFL++ vs LibFuzzer vs Honggfuzz',
    content: '주요 퍼징 도구들의 성능과 코드 커버리지를 비교 분석한 연구입니다. 실제 오픈소스 프로젝트 10개를 대상으로 30일간 테스트한 결과와 각 도구의 장단점 분석.',
    tags: ['fuzzing', 'afl', 'libfuzzer', 'research'],
    status: 'solved',
    likes_count: 278,
    replies_count: 54,
    views_count: 4123,
    created_at: new Date(Date.now() - 120 * 3600000).toISOString(),
    profiles: {
      id: 'researcher9',
      username: 'fuzzing_researcher',
      display_name: 'Fuzzing Researcher',
      points: 5340,
      reputation: 1089
    }
  },
  {
    id: 'knowledge22',
    user_id: 'researcher10',
    type: 'knowledge' as const,
    title: 'Side-Channel Attack 연구 - Spectre 변종 분석',
    content: 'Spectre 취약점의 새로운 변종을 발견하고 분석한 연구입니다. 최신 CPU의 추측 실행 메커니즘을 악용하여 커널 메모리 유출이 가능함을 증명. PoC 코드와 완화 방안 제시.',
    tags: ['side-channel', 'spectre', 'cpu', 'research'],
    status: 'open',
    likes_count: 345,
    replies_count: 71,
    views_count: 5234,
    created_at: new Date(Date.now() - 126 * 3600000).toISOString(),
    profiles: {
      id: 'researcher10',
      username: 'hardware_researcher',
      display_name: 'Hardware Researcher',
      points: 6120,
      reputation: 1356
    }
  },
  {
    id: 'knowledge23',
    user_id: 'researcher11',
    type: 'knowledge' as const,
    title: 'Blockchain 스마트 컨트랙트 취약점 자동 탐지 도구 개발',
    content: 'Solidity 스마트 컨트랙트의 일반적인 취약점을 자동으로 탐지하는 정적 분석 도구를 개발했습니다. Reentrancy, Integer Overflow, Access Control 등 주요 취약점 패턴 탐지 가능.',
    tags: ['blockchain', 'smart-contract', 'static-analysis', 'research'],
    status: 'open',
    likes_count: 289,
    replies_count: 57,
    views_count: 4456,
    created_at: new Date(Date.now() - 132 * 3600000).toISOString(),
    profiles: {
      id: 'researcher11',
      username: 'blockchain_researcher',
      display_name: 'Blockchain Researcher',
      points: 5670,
      reputation: 1178
    }
  },
  {
    id: 'knowledge24',
    user_id: 'researcher12',
    type: 'knowledge' as const,
    title: 'IoT 디바이스 펌웨어 자동 분석 프레임워크 연구',
    content: 'IoT 디바이스 펌웨어를 자동으로 추출하고 분석하는 프레임워크를 개발했습니다. 바이너리 분석, 하드코딩된 자격증명 탐지, 취약한 암호화 알고리즘 탐지 등 기능 포함.',
    tags: ['iot', 'firmware', 'automation', 'research'],
    status: 'solved',
    likes_count: 256,
    replies_count: 49,
    views_count: 3987,
    created_at: new Date(Date.now() - 138 * 3600000).toISOString(),
    profiles: {
      id: 'researcher12',
      username: 'iot_researcher',
      display_name: 'IoT Researcher',
      points: 5230,
      reputation: 1045
    }
  },
  {
    id: 'knowledge25',
    user_id: 'researcher13',
    type: 'knowledge' as const,
    title: 'Zero Trust Architecture 구현 사례 연구',
    content: '대규모 엔터프라이즈 환경에서 Zero Trust 아키텍처를 구현한 사례 연구입니다. 마이크로 세그멘테이션, 지속적 인증, 최소 권한 원칙 적용 등 실제 구현 과정과 결과 공유.',
    tags: ['zero-trust', 'architecture', 'enterprise', 'research'],
    status: 'open',
    likes_count: 298,
    replies_count: 61,
    views_count: 4567,
    created_at: new Date(Date.now() - 144 * 3600000).toISOString(),
    profiles: {
      id: 'researcher13',
      username: 'architecture_researcher',
      display_name: 'Architecture Researcher',
      points: 5560,
      reputation: 1123
    }
  }
];